/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: BI Cloud (C)
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
// This file is used to create the require layers. Only the entry points are necessary
define([
	'./BaseSlideoutActionHandler',
	'./CustomWidgetActionHandler',
	'./LegacyOpenActionHandler',
	'./ModeActionHandler',
	'./OpenActionHandler',
	'./OpenTemplateActionHandler',
	'./PinningActionHandler',
	'./RedoActionHandler',
	'./SaveActionHandler',
	'./SaveAsTemplateActionHandler',
	'./ShareActionHandler',
	'./UndoActionHandler',
	'./WidgetBaseActionHandler',
	'./WidgetsPanelHandler',
	'./SlotEditorActionHandler',
	'./CustomContentActionHandler'
], function() {
	'use strict';
});
